



















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDynamsoftLicenseHelperStore } from "@/employee/store/dynamsoftLicenseHelper";

let barcodeReader;
let cameraEnhancer;
let cameraView;

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class BarcodeReader extends Vue {
  @Prop({ required: true })
  isVisible: boolean;

  @Prop({ required: false })
  supportedFormats: string[];

  @Prop({ required: false })
  minLength: number;

  @Prop({ required: false })
  maxLength: number;

  dynamsoftLicenseHelperStore = useDynamsoftLicenseHelperStore();

  scannerResult = "";
  isLoading = true;

  async created () {
    try {
      await this.dynamsoftLicenseHelperStore.initLicense();
    } catch (err) {
      this.$emit("close");
    }
  }

  mounted () {
    document.addEventListener("deviceready", this.startScanner, false);
    document.addEventListener("pause", this.stop, false);
    document.addEventListener("resume", this.start, false);
  }

  async startScanner () {
    this.scannerResult = "";
    await this.setupBarcodeReader();
    await this.setupCameraView();
    this.start();
  }

  async setupBarcodeReader () {
    barcodeReader = barcodeReader || await (window as any).Dynamsoft.DCVBarcodeReader.createInstance();
    // Get the current runtime settings of the barcode reader.
    const settings = await barcodeReader.getRuntimeSettings();
    // Set the expected barcode count to 0 when you are not sure how many barcodes you are scanning.
    // Set the expected barcode count to 1 can maximize the barcode decoding speed.
    settings.expectedBarcodesCount = 1;
    // Apply the new settings to the barcode reader.
    barcodeReader.updateRuntimeSettings(settings);
    // DBR offers several preset templates for different popular scenarios.
    // For the full set of templates:
    // https://www.dynamsoft.com/capture-vision/docs/programming/cordova/api-reference/enum-dbr-preset-template.html
    // Template helps to prioritize a specific use case
    barcodeReader.updateRuntimeSettings((window as any).Dynamsoft.EnumDBRPresetTemplate.VIDEO_SINGLE_BARCODE);
    barcodeReader.addResultListener(results => {
      if (results && results.length > 0) {
        const barcodeFormat = results[0].barcodeFormatString.trim().toUpperCase();
        const barcodeText = results[0].barcodeText.trim().toUpperCase();

        if (this.isValidBarcode(barcodeFormat, barcodeText)) {
          this.onValidBarcodeFound(barcodeText);
        } else {
          this.scannerResult = "Not supported. Please try another product.";
        }
      } else {
        this.scannerResult = "No barcode detected in this frame.";
      }
    });
  }

  async setupCameraView () {
    cameraEnhancer = cameraEnhancer || await (window as any).Dynamsoft.DCVCameraEnhancer.createInstance();

    const cameraViewElement = document.getElementById("camera_view");

    cameraView = cameraView || new (window as any).Dynamsoft.DCVCameraView();

    cameraView.setOverlayVisible(true);

    cameraView.bindToHtmlElement(cameraViewElement);
  }

  isValidBarcode (format: string, code: string): boolean {
    if ((this.supportedFormats === undefined || this.supportedFormats.length === 0 ||
            this.supportedFormats.includes(format))
        && (this.minLength === undefined || !Number(this.minLength) || code.length === this.minLength
            || this.maxLength === undefined || !Number(this.maxLength) || code.length === this.maxLength)) {
      return true;
    }
    return false;
  }

  onValidBarcodeFound (barcode: string) {
    this.close();
    this.$emit("success", barcode);
  }

  removeEventListeners () {
    document.removeEventListener("deviceready", this.startScanner);
    document.removeEventListener("pause", this.stop);
    document.removeEventListener("resume", this.start);
  }

  close () {
    this.stop();
    this.$emit("close");
  }

  start () {
    cameraEnhancer.open();
    barcodeReader.startScanning();
    this.isLoading = false;
  }

  stop () {
    cameraEnhancer.close();
    barcodeReader.stopScanning();
  }

  beforeDestroy () {
    this.removeEventListeners();
    this.stop();
  }
}
